module.exports = __webpack_public_path__ + "img/4.9c415ab9.png";